import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { ScheduleSlotPicker } from '@/components/advertise/ScheduleSlotPicker';
import { useAdvertise } from '@/store/useAdvertise';
import { useStepGuard, agentsStepValid } from '@/utils/advertiseGuards';
import { AGENTS_STEPS } from '@/config/advertiseSteps';

export default function AgentsSchedule() {
  const navigate = useNavigate();
  const agents = useAdvertise((s) => s.agents);
  const setField = useAdvertise((s) => s.setField);
  useStepGuard(agentsStepValid.schedule(agents), '/advertise/agents');

  const goNext = () => navigate('/advertise/agents/review');

  return (
    <AdvertiseLayout
      trackLabel="Agent advertising"
      steps={AGENTS_STEPS}
      currentStepId="schedule"
      title="Pick a time for a quick walkthrough"
      subtitle="15 minutes with our team — or skip and we'll follow up by email instead."
      sidebar={<AdvertiseSideSummary items={[{ label: 'Demo time', value: agents.slotLabel }]} />}
      footer={
        <AdvertiseFooterNav
          onBack={() => navigate('/advertise/agents/goals')}
          onNext={goNext}
          nextDisabled={!agents.slotIso}
          nextLabel="Continue"
          secondaryAction={
            <Button type="button" variant="ghost" onClick={() => { setField('agents', { slotIso: '', slotLabel: '' }); goNext(); }} className="rounded-xl text-slate-500">
              Skip — email me instead
            </Button>
          }
        />
      }
    >
      <ScheduleSlotPicker
        track="agents"
        value={agents.slotIso ? { iso: agents.slotIso } : null}
        onChange={(slot) => setField('agents', { slotIso: slot.iso, slotLabel: slot.label })}
      />
    </AdvertiseLayout>
  );
}
